import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as CreatedIcon } from "../../../../../assets/images/People/Teams/created.svg";
import { ReactComponent as StatusIcon } from "../../../../../assets/images/People/Customers/status.svg";
import StatusChip from "../../StatusChip";

const sectionCardSx = {
  width: "100%",
  maxWidth: 632,
  height: 104,
  borderRadius: "8px",
  border: "1px solid #E5E9EC",
  background: "#FFF",
  px: 3,
  py: 3,
  boxSizing: "border-box",
  display: "flex",
  alignItems: "center",
};

const labelSx = {
  color: "#405261",
  fontFamily: "Inter",
  fontSize: 14,
  fontWeight: 400,
  lineHeight: "18px",
};

const valueSx = {
  color: "#061522",
  fontFamily: "Inter",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "18px",
};

function InfoField({ icon: Icon, label, children }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: "16px",
        minWidth: 0,
      }}
    >
      <Box sx={{ flexShrink: 0, lineHeight: 0, width: 24, height: 24 }}>
        <Icon style={{ width: 24, height: 24, display: "block" }} />
      </Box>
      <Box sx={{ minWidth: 0, display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            height: 24,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography component="span" sx={labelSx}>
            {label}
          </Typography>
        </Box>
        <Box
          sx={{
            height: 32,
            display: "flex",
            alignItems: "center",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export default function GroupDetailInfoSection({ group }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "34px",
          mb: 2,
        }}
      >
        Information
      </Typography>
      <Box sx={sectionCardSx}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            columnGap: 3,
            rowGap: 2,
            width: "100%",
            alignItems: "center",
          }}
        >
          <InfoField icon={CreatedIcon} label="Created">
            <Typography component="span" sx={valueSx}>
              {group.createdDisplay}
            </Typography>
          </InfoField>
          <InfoField icon={StatusIcon} label="Status">
            <StatusChip status={group.status} withDot />
          </InfoField>
        </Box>
      </Box>
    </Box>
  );
}
